
//http://api.thelottofactory.com/v1/purchase/plan?PlanId=
function PlansSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'plans'
	return $resource(odataUrl, { OrganizationId: '@OrganizationId' }, {
      get: { method: 'GET', params: {}, isArray: true }
  });
};

export default {
  name: "PlansSvc",
  fn: PlansSvc
}